const housesFilter = {
    _filter: null,
    _filterForm: null,
    _filterContent: null,
    _checkboxes: null,

    init() {
        if(! document.querySelector('.js-filter')) {
            return;
        }

        let self = this;
        self._construct();
    },

    toggleFilter(node) {
        node.parentElement.classList.toggle('js-filter--opened');
    },

    _construct() {
        let self = this;

        self._filter = document.querySelector('.js-filter');
        self._filterForm = document.querySelector('.js-filter-form')
        self._filterContent = document.querySelector('.js-filter-content');

        self._filterFormBehaviour();

    },

    _filterFormBehaviour() {
        let self = this;

        self._checkboxes = self._filterForm.querySelectorAll('input[type="checkbox"]');
        self._checkboxes.forEach(checkbox => {
            checkbox.addEventListener('change', self._hideNodes.bind(self), false);
        });
    },

    _hideNodes() {
        let self = this;
        const categories = [];
        self._checkboxes.forEach(checkbox => {
            if(checkbox.checked) {
                categories.push(checkbox.dataset.category);
            }
        });

        const nodes = self._filterContent.querySelectorAll('article[data-categories]');
        nodes.forEach(node => {
            if(categories.length === 0) {
                node.classList.remove('hidden');
            }
            else {
                let nodeCategories = JSON.parse(node.dataset.categories);
                let difference = nodeCategories.filter(x => categories.includes(x));
                
                if(difference.length === 0) {
                    console.log(node);
                    node.classList.add('hidden');
                } 
                else {
                    node.classList.remove('hidden');
                }
            }
            
        });
        
    }

}

window.housesFilter = housesFilter;

window.housesFilter.init();

document.addEventListener('LokiRequestEnd', function () {
    window.housesFilter.init();
});
